import { AppBar, Button, Dialog, Divider, IconButton, InputAdornment, List, ListItem, ListItemText, TextField, ThemeProvider, Toolbar, Typography, createTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import React, { Component } from 'react';
import Settings from './Settings';

interface SettingsDialogProps {
    open: boolean;
    handleClose?: (success: boolean, settings: Settings) => void;
    UserFtp?: number;
    UserWeight?: number;
}

interface SettingsDialogState {
    UserFtp: number;
    UserWeight?: number;
}

export default class SettingsDialog extends Component<SettingsDialogProps, SettingsDialogState> {

    constructor(props: SettingsDialogProps) {
        super(props);
        this.state= { 
            UserFtp: props.UserFtp ?? 100,
            UserWeight: props.UserWeight
        };
    }

    onComponentDidMount() {
        this.setState({
            UserFtp: this.props.UserFtp ?? 100,
            UserWeight: this.props.UserWeight,
        });
    }

    private onClose(success: boolean) {
        if (this.props.handleClose) {
            var settings = {
                UserDataFtp: this.state.UserFtp,
                UserDataWeight: this.state.UserWeight,
            } as Settings;
            this.props.handleClose(success, settings);
        }
    }

    render() {
        return (
            <Dialog open={this.props.open} fullScreen>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton className='button' edge="start" color="inherit" onClick={() => this.onClose(false)}>
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Settings
                        </Typography>
                        <Button className='button' autoFocus color="inherit" onClick={() => this.onClose(true)}>
                            Save
                        </Button>
                    </Toolbar>
                </AppBar>

                <div style={{margin: "1rem"}}>
                    <TextField id="ftp" label="FTP" variant="outlined" onChange={(event) => {this.setState({UserFtp: parseInt(event.target.value)})}}
                        value={this.state.UserFtp}
                        onFocus={event => event.target.select()}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">W</InputAdornment>,
                        }}/>
                    <TextField id="weight" label="Weight" variant="outlined" 
                        value={this.state.UserWeight}
                        onFocus={event => event.target.select()}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                        }}/>
                </div>
            </Dialog>
        );
    }
}
